import React from 'react';
import Abnormal from '@/pages/dashboard/components/Abnormal';

const FunnelStepCardContext = (props: any) => {

  const { children, style, data, ...restProps } = props;
  const { errorMsg,loading} = data?.funnelCardList;
  const isWideScreen = window.innerWidth >= 1920;

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        data,
        ...restProps,
      }
    ))
  );

  return (
    <Abnormal
      isLoading={loading}
      isError={errorMsg}
      style={{ background: '#fff', marginTop: '20px', height: isWideScreen ? '293px' : '248px', ...style}}
      component={componentItem}
    />
  );
};

export default FunnelStepCardContext;
